import { Translate } from "@mui/icons-material";

export const TranslationsTabHeader = () => {
  return (
    <span style={{ display: "" }}>
      <Translate /> <span style={{ verticalAlign: "super" }}>Translations</span>
    </span>
  );
};
